import React from 'react';
import { MentionsInput as MentionsInputReact, Mention } from 'react-mentions';
import styles from './MentionsInput.module.css';

const MentionsInput = (props) => {
  const mentionTransform = (e) => {
    if (props.trigger) return props.trigger + e;
    return e;
  };

  return (
    <>
      <span className={styles.Label}>{props.label}</span>
      <MentionsInputReact
        multiline
        placeholder={props.placeholder}
        value={props.value}
        onChange={props.onChange}
        className="MentionsInput"
        classNames={styles}
      >
        <Mention
          className={styles.Mention}
          trigger={props.trigger}
          data={props.suggestions}
          appendSpaceOnAdd
          displayTransform={mentionTransform}
          markup="@__display__ "
        />
      </MentionsInputReact>
      {props.info ? <div className={styles.Info}>{props.info}</div> : null}
    </>
  );
};

export default MentionsInput;
